<template>
    <div>
        <PageHeader :title="$t('pages.contacts.title')"
                    :desc="$t('pages.contacts.desc')"/>
        <PageFrameContainer>
            <div class="contacts-container">
                <p class="contacts-info">
                    {{$t('pages.contacts.contactsInfo')}}
                </p>
                <div>
                    <Loader v-if="submitting === true">{{$t('pages.contacts.sending')}} ...</Loader>
                    <div v-else class="contact-page-container">
                        <div class="contact-form">
                            <label for="name">{{$t('pages.contacts.contactForm.name')}}</label>
                            <input type="text" id="name" v-model="userName"/>
                            <label for="email">{{$t('pages.contacts.contactForm.email')}}</label>
                            <input type="text" id="email" v-model="userEmail"/>
                            <label for="message">{{$t('pages.contacts.contactForm.message')}}</label>
                            <textarea id="message" v-model="message"></textarea>
                            <div>
                                <input id="agree" type="checkbox" v-model="agree">
                                <label for="agree">{{$t('pages.contacts.contactForm.agree')}}
                                    <router-link class="router-link-terms" title="terms" tag="a"
                                                 :to="{ name: 'termsAndConditions'}">
                                        {{$t('pages.contacts.contactForm.terms')}}&nbsp;&rarr;
                                    </router-link>
                                </label>
                            </div>
                            <p>{{response}}</p>
                            <button v-on:click="send" :disabled="agree !== true">
                                {{$t('pages.contacts.contactForm.send')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </PageFrameContainer>
    </div>
</template>

<script>
    import PageFrameContainer from "./components/PageFrameContainer";
    import Loader from "./components/Loader";
    import PageHeader from "./components/PageHeader";

    export default {
        name: "ContactPage",
        components: {PageHeader, PageFrameContainer, Loader},
        props: {
            userName: String,
            userEmail: String,
            message: String,
            submitting: Boolean,
            response: String
        },
        data: function () {
            return {
                agree: false
            }
        },
        methods: {
            async send() {
                this.submitting = true;
                try {
                    const formData = new FormData();
                    formData.append('name', this.userName);
                    formData.append('email', this.userEmail);
                    formData.append('text', this.message);

                    let response = await window.fetch(`${window.oneblendingHostApi}/feedback/post`, {
                        method: 'POST',
                        mode: 'cors',
                        body: formData
                    });

                    if (response.status === 200) {
                        let data = await response.json();
                        this.response = `${this.$i18n.t('pages.contacts.messageSendInfo')}${data.id}`;

                    } else if (response.status !== 200) {
                        this.response = "Message not sent. Try again later"
                    }
                } finally {
                    this.submitting = false;
                    this.userName = "";
                    this.userEmail = "";
                    this.message = "";
                    this.agree = false;
                }

            }
        }
    }
</script>

<style scoped lang="scss">
    @import "theme/theme";

    .contacts-container {
        display: grid;
        grid-template-columns: 1fr 3fr;
        grid-template-rows: auto;

        .contacts-info {
            font-size: 0.9rem;
            font-weight: 300;
            padding-left: 1rem;
            padding-right: 1rem;
            color: $primary20;
            margin-bottom: 1em;
        }

        @media (max-width: 45em) {
            .contacts-info {
                font-size: 0.7rem;
                padding-left: 0.1rem;
                padding-right: 1rem;
            }
        }

        @media (min-width: 45em) {
            .contacts-info {
                font-size: 0.9rem;
            }
        }

        .contact-page-container {
            margin-bottom: 3rem;

            .contact-form {
                display: grid;
                grid-gap: 0.6em;
                align-self: start;
                max-width: 30em;
                margin-left: auto;
                margin-right: auto;

                label {
                    color: $text80;
                }

                input {
                    padding: 0.2em 0.6em;
                    font-size: 1.1rem;
                    border-width: 1px;
                    border-color: $text40;
                    background-color: $back20;
                    color: $text100;
                    border-style: solid;
                    border-radius: 0.3em;
                }

                input:focus {
                    border-color: $primary60;
                    outline: none;
                }

                textarea {
                    padding: 0.2em 0.6em;
                    font-size: 1.1rem;
                    border-width: 1px;
                    border-color: $text40;
                    background-color: $back20;
                    color: $text100;
                    border-style: solid;
                    border-radius: 0.3em;
                    height: 6em;
                }

                textarea:focus {
                    border-color: $primary60;
                    outline: none;
                }

                button {
                    margin-right: 1em;
                    padding: 0.7em 2em;
                    background: $primary100;
                    border-radius: 0.4em;
                    border-color: $back20;
                    border-width: 1px;
                    border-style: solid;
                    text-decoration: none;
                    text-effect: none;
                    font-size: 1em;
                    cursor: pointer;
                    color: $primaryText100;
                    justify-self: right;
                    outline: none;
                }

                button:hover {
                    background: $primary40;
                }

                button:disabled,
                button[disabled] {
                    background: $back60;
                }

                input[type=checkbox] {
                    margin-right: 0.5rem;
                }

                a {
                    font-size: 1em;
                    color: $text100;
                    text-decoration: none;
                    text-effect: none;
                    cursor: pointer;
                    margin-top: 0.5rem;
                    margin-right: 3rem;
                    border-bottom: 1px solid $primaryText100;
                }

                a:hover {
                    //background: $primary40;
                    border-bottom: 1px solid $text60;
                    color: $text80;
                }
            }
        }
    }
</style>